import { render } from "./Example4.vue?vue&type=template&id=4261f245"
import script from "./Example4.vue?vue&type=script&lang=ts"
export * from "./Example4.vue?vue&type=script&lang=ts"
script.render = render

export default script